import { darken, getValue } from "../utils.js";

export const EMAIL = {
  "Email.Bg.Color": {
    ref: "Singleline.Bg.Color"
  },
  "Email.Border.Top.Left.Radius": {
    ref: "Singleline.Border.Top.Left.Radius"
  },
  "Email.Border.Top.Right.Radius": {
    ref: "Singleline.Border.Top.Right.Radius"
  },
  "Email.Border.Bottom.Left.Radius": {
    ref: "Singleline.Border.Bottom.Left.Radius"
  },
  "Email.Border.Bottom.Right.Radius": {
    ref: "Singleline.Border.Bottom.Right.Radius"
  },
  "Email.Border.Color": {
    ref: "Singleline.Border.Color",
    referredIn: ["Email.Hover.Border.Color"]
  },
  "Email.Border.Left.Width": {
    ref: "Singleline.Border.Left.Width"
  },
  "Email.Border.Right.Width": {
    ref: "Singleline.Border.Right.Width"
  },
  "Email.Border.Top.Width": {
    ref: "Singleline.Border.Top.Width"
  },
  "Email.Border.Bottom.Width": {
    ref: "Singleline.Border.Bottom.Width"
  },
  "Email.Color": {
    ref: "Singleline.Color"
  },
  "Email.Font.Size": {
    ref: "Singleline.Font.Size"
  },
  "Email.Font.Weight": {
    ref: "Singleline.Font.Weight"
  },
  "Email.Line.Height": {
    ref: "Singleline.Line.Height"
  },
  "Email.Letter.Spacing": {
    ref: "Singleline.Letter.Spacing"
  },
  "Email.Padding.Left": {
    ref: "Singleline.Padding.Left"
  },
  "Email.Padding.Right": {
    ref: "Singleline.Padding.Right"
  },
  "Email.Padding.Top": {
    ref: "Singleline.Padding.Top"
  },
  "Email.Padding.Bottom": {
    ref: "Singleline.Padding.Bottom"
  },
  "Email.Shadow": {
    ref: "Singleline.Shadow"
  },
  "Email.Hover.Border.Color": {
    valueFunc: (meta) => {
      return darken(getValue("Email.Border.Color", meta), 0.2);
    }
  },
  "Email.Focus.Bg.Color": {
    ref: "Singleline.Focus.Bg.Color"
  },
  "Email.Focus.Border.Color": {
    ref: "Singleline.Focus.Border.Color"
  },
  "Email.Focus.Border.Left.Width": {
    ref: "Singleline.Focus.Border.Left.Width"
  },
  "Email.Focus.Border.Right.Width": {
    ref: "Singleline.Focus.Border.Right.Width"
  },
  "Email.Focus.Border.Top.Width": {
    ref: "Singleline.Focus.Border.Top.Width"
  },
  "Email.Focus.Border.Bottom.Width": {
    ref: "Singleline.Focus.Border.Bottom.Width"
  },
  "Email.Focus.Shadow": {
    ref: "Singleline.Focus.Shadow"
  },
  "Email.Readonly.Bg.Color": {
    ref: "Singleline.Readonly.Bg.Color"
  },
  "Email.Readonly.Border.Color": {
    ref: "Singleline.Readonly.Border.Color"
  },
  "Email.Readonly.Border.Left.Width": {
    ref: "Singleline.Readonly.Border.Left.Width"
  },
  "Email.Readonly.Border.Right.Width": {
    ref: "Singleline.Readonly.Border.Right.Width"
  },
  "Email.Readonly.Border.Top.Width": {
    ref: "Singleline.Readonly.Border.Top.Width"
  },
  "Email.Readonly.Border.Bottom.Width": {
    ref: "Singleline.Readonly.Border.Bottom.Width"
  },
  "Email.Readonly.Shadow": {
    ref: "Singleline.Readonly.Shadow"
  },
  "Email.Disabled.Bg.Color": {
    ref: "Singleline.Disabled.Bg.Color"
  },
  "Email.Disabled.Border.Color": {
    ref: "Singleline.Disabled.Border.Color"
  },
  "Email.Disabled.Color": {
    ref: "Singleline.Disabled.Color"
  },
  "Email.Error.Bg.Color": {
    ref: "Singleline.Error.Bg.Color"
  },
  "Email.Error.Border.Color": {
    ref: "Singleline.Error.Border.Color"
  },
  "Email.Icon.Size": {
    ref: "Singleline.Icon.Size"
  },
  "Email.Icon.Color": {
    ref: "Singleline.Icon.Color"
  }
};
